// extracted by mini-css-extract-plugin
export var statItem = "_i7-1";
export var statsRow = "_i7-0";